import { render } from "./contract_lifecycle.html?vue&type=template&id=6be1288d&external"
import script from "./contract_lifecycle.js?vue&type=script&lang=js&external"
export * from "./contract_lifecycle.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__